React = require 'react'
gray = require 'gray-percentage'

module.exports = React.createClass
  displayName: 'Styleguide'

  render: ->
    React.createElement("div", null,
      React.createElement("h1", null, "Typography.js"),

      React.createElement("h5", null, "An opinionated toolkit for building websites with beautiful typography."),

      React.createElement("a", {"href": "https://github.com/KyleAMathews/typography.js"}, "Code on Github"),
      React.createElement("br", null),
      React.createElement("br", null),

      React.createElement("hr", null),

      React.createElement("h1", {"id": "paragraph"}, "Paragraph"),

      React.createElement("p", null, "Lorem ipsum dolor sit amet, ", React.createElement("a", {"href": "http://google.com"}, "test link"), " adipiscing elit. Nullam dignissim convallis est. Quisque aliquam. Donec faucibus. Nunc iaculis suscipit dui. Nam sit amet sem. Aliquam libero nisi, imperdiet at, tincidunt nec, gravida vehicula, nisl. Praesent mattis, massa quis luctus fermentum, turpis mi volutpat justo, eu volutpat enim diam eget metus. Maecenas ornare tortor. Donec sed tellus eget sapien fringilla nonummy. Mauris a ante. Suspendisse quam sem, consequat at, commodo vitae, feugiat in, nunc. Morbi imperdiet augue quis tellus."),

      React.createElement("h2", null, "A nice subheading"),

      React.createElement("p", null, "Lorem ipsum dolor sit amet, ", React.createElement("em", null, "emphasis"), " consectetuer adipiscing elit. Nullam dignissim convallis est. Quisque aliquam. Donec faucibus. Nunc iaculis suscipit dui. Nam sit amet sem. Aliquam libero nisi, imperdiet at, tincidunt nec, gravida vehicula, nisl. Praesent mattis, massa quis luctus fermentum, turpis mi volutpat justo, eu volutpat enim diam eget metus. Maecenas ornare tortor. Donec sed tellus eget sapien fringilla nonummy. Mauris a ante. Suspendisse quam sem, consequat at, commodo vitae, feugiat in, nunc. Morbi imperdiet augue quis tellus."),

      React.createElement("hr", null),

      React.createElement("h1", {"id": "headings"}, "Headings"),

      React.createElement("h1", null, "Heading 1"),
      React.createElement("h2", null, "Heading 2"),
      React.createElement("h3", null, "Heading 3"),
      React.createElement("h4", null, "Heading 4"),
      React.createElement("h5", null, "Heading 5"),
      React.createElement("h6", null, "Heading 6"),

      React.createElement("hr", null),

      React.createElement("h1", {"id": "list_types"}, "List Types"),

      React.createElement("h3", null, "Definition List"),
      React.createElement("dl", null,
        React.createElement("dt", null, "Definition List Title"),
        React.createElement("dd", null, "This is a definition list division.")
      ),

      React.createElement("h3", null, "Ordered List"),
      React.createElement("ol", null,
        React.createElement("li", null, "List Item 1"),
        React.createElement("li", null, "List Item 2"),
        React.createElement("li", null, "List Item 3"),
        React.createElement("ol", null,
          React.createElement("li", null, "List Item 1"),
          React.createElement("li", null, "List Item 2"),
          React.createElement("li", null, "List Item 3")
        )
      ),

      React.createElement("h3", null, "Unordered List"),
      React.createElement("ul", null,
        React.createElement("li", null, "List Item 1"),
        React.createElement("li", null, "List Item 2"),
        React.createElement("li", null, "List Item 3"),
        React.createElement("ul", null,
          React.createElement("li", null, "List Item 1"),
          React.createElement("li", null, "List Item 2"),
          React.createElement("li", null, "List Item 3")
        )
      ),

      React.createElement("hr", null),

      React.createElement("h1", {"id": "tables"}, "Tables"),

      React.createElement("table", null,
        React.createElement("thead", null,
          React.createElement("tr", null,
            React.createElement("th", null, "Table Header 1"), React.createElement("th", null, "Table Header 2"), React.createElement("th", null, "Table Header 3")
          )
        ),
        React.createElement("tbody", null,
          React.createElement("tr", null,
            React.createElement("td", null, "Division 1"), React.createElement("td", null, "Division 2"), React.createElement("td", null, "Division 3")
          ),
          React.createElement("tr", null,
            React.createElement("td", null, "Division 1"), React.createElement("td", null, "Division 2"), React.createElement("td", null, "Division 3")
          ),
          React.createElement("tr", null,
            React.createElement("td", null, "Division 1"), React.createElement("td", null, "Division 2"), React.createElement("td", null, "Division 3")
          )
        )
      ),

      React.createElement("br", null),
      React.createElement("hr", null),

      React.createElement("h1", {"id": "misc"}, "Misc Stuff - abbr, sub, sup, pre, blockquote etc."),

      React.createElement("p", null, "Lorem ", React.createElement("sup", null, "superscript"), " dolor ", React.createElement("sub", null, "subscript"), " amet, consectetuer adipiscing elit. Nullam dignissim convallis est. Quisque aliquam. ", React.createElement("cite", null, "cite"), ". Nunc iaculis suscipit dui. Nam sit amet sem. Aliquam libero nisi, imperdiet at, tincidunt nec, gravida vehicula, nisl. Praesent mattis, massa quis luctus fermentum, turpis mi volutpat justo, eu volutpat enim diam eget metus. Maecenas ornare tortor. Donec sed  tellus eget sapien fringilla nonummy. Mauris a ante. Suspendisse quam sem, consequat at, commodo vitae, feugiat in, nunc. Morbi imperdiet augue quis tellus.  ", React.createElement("abbr", {"title": "Avenue"}, "AVE")),

      React.createElement("h3", null, "Bivouac on a mountain side."),
      React.createElement("pre", null, """
I see before me now a traveling army halting,
Below a fertile valley spread, with barns and the orchards of
       summer,
Behind, the terraced sides of a mountain, abrupt, in places rising
       high,
Broken, with rocks, with clinging cedars, with tall shapes dingily
       seen,
The numerous camp-fires scatter\'d near and far, some away up on
       the mountain,
The shadowy forms of men and horses, looming, large-sized,
       flickering,
And over all the sky—the sky! far, far out of reach, studded,
       breaking out, the eternal stars.
"""),

      React.createElement("blockquote", null,
        React.createElement("p", null, "There is indeed an element of luck, and no, there isn’t. The prepared mind sooner or later finds something important and does it. So yes, it is luck. The particular thing you do is luck, but that you do something is not."),
        React.createElement("cite", null, "—Richard Hamming")
      ),

      React.createElement("hr", null),

      React.createElement("h1", {"id": "code"}, "Code"),
      React.createElement("pre", null,
        React.createElement("code", {"ref": "code"},
        ('''
          code {
            @include border-radius(3px);
            @include force-wrap();
            background: gray(90%);
            border: 1px solid gray(80%);
            display: inline;
            font-family: Inconsolata, monospace, serif;
            font-size: 16px;
            line-height: 20px;
            max-width: 100%;
            overflow: auto;
            padding: 0 rhythm(0.125);
          }
        ''')
        )
      ),

      React.createElement("hr", null),

      React.createElement("h1", null, "This is an example of Heading 1"),
      React.createElement("p", null, "A simple paragraph. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."),
      React.createElement("h2", null, "This is an example of heading 2"),
      React.createElement("p", null, "A simple paragraph. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."),
      React.createElement("h3", null, "This is an example of heading 3"),
      React.createElement("p", null, "A simple paragraph. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."),
      React.createElement("h4", null, "This is an example of heading 4"),
      React.createElement("p", null, "A simple paragraph. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."),
      React.createElement("h5", null, "This is an example of heading 5"),
      React.createElement("p", null, "A simple paragraph. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."),
      React.createElement("h6", null, "This is an example of heading 6"),
      React.createElement("p", null, "A simple paragraph. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.")
    )



/** WEBPACK FOOTER **
 ** ../~/cjsx-loader!./old-styleguide.cjsx
 **/